import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from "../../Types";
import moment from "moment";
import {nanoid} from "@reduxjs/toolkit";


let fieldOperations: FieldOperations = {
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
    dt: [...OpsCategories.range],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    name: [...OpsCategories.like],
    prize_id: [...OpsCategories.in],
    rate: [...OpsCategories.range],
    orders: [...OpsCategories.range],
    deleted: [...OpsCategories.eq],
    ur_osoba_invite: [...OpsCategories.eq],
};

export function orders287DefFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.GREATER_THAN_OR_EQUAL,
            locked: true,
            value: moment().subtract(7, 'days').startOf('day').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.LESS_THAN_OR_EQUAL,
            locked: true,
            value: moment().endOf('day').locale('en').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'msisdn',
            type: 'tel',
            filterOp: SqlOperation.LIKE,
            locked: true,
            value: ''
        }
    ]
}

export const OrdersTable: TableI = {
    backend: "/287/",
    title: {
        ua: "Замовлення",
        en: "Замовлення",
    },
    pk: 'id',
    defaultOrderedBy: "id",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "id": {ua: "ID", en: "№"},
        "dt": {ua: "Створено", ru: "Дата"},
        "rate": {ua: "Бали", ru: "Уровень"},
        "orders": {ua: "Замовлень", ru: "Подтвержденый"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'orders287DefFilters',
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№", ru: "№"}, type: "number",
            applyTransform: true
        }, {
            key: "id",
            detailed: true,
            title: {ua: "ID", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "dt",
            title: {ua: "Дата", ru: "Дата"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
            headAlign: "left",
        },
        {
            key: "msisdn", type: 'tel',
            applyTransform: true,
            headAlign: "left",
            detailed: true, inline: true, title: {ua: "Телефон", ru: "Телефон"},
            searchRef: [
                {
                    table: "orders",
                    condition: [{
                        mainField: "msisdn",
                        op: SqlOperation.LIKE
                    }]
                }
            ]
        },
        {key: "user_name", type: 'string', inline: true, title: {ua: "Користувач"},headAlign: "left",},
        {
            key: "prize_id",
            title: {ua: "Подарунок", ru: "Уровень"},
            detailed: true,
            inline: true,
            headAlign: "left",
            applyTransform: true,
            type: "map",
            map: {
                async: 'all_prizes'
            } as FieldMap,
            searchRef: [
                {
                    table: "orders",
                    condition: [{
                        mainField: "prize_id",
                        op: SqlOperation.IN
                    }]
                }
            ]
        },
        {
            key: "rate",
            type: "number",
            title: {ua: "Балів"},
            detailed: true,
            inline: true,
            headAlign: "left",
        },
        {key: "orders", title: {ua: "Заказів"}, type: "number", inline: true, headAlign: "left",},
        {
            key: "comment",
            title: {ua: "Коментар"},
            detailed: true,
            editable: true,
            type: 'string'
        },
        {
            key: "deleted",
            title: {ua: "Видалений", ru: "Комментарий"},
            detailed: true,
            editable: true,
            applyTransform: true,
            type: 'boolean'
        },
        {
            key: "ur_osoba_invite",
            title: {ua: "Як ЮР. Особа за запрошення"},
            detailed: true,
            editable: true,
            applyTransform: true,
            type: 'boolean'
        },
        {
            key: "ref_user",
            title: {ua: "Користувач"},
            detailed: true,
            applyTransform: true,
            type: 'ref',
            ref: {
                entity: "user",
                order: {
                    field: "id",
                    way: "DESC"
                },
                limit: 1,
                single: true,
                fetchMode: "lazy",
                layout: "vertical-list",
                condition: [{
                    mainField: "msisdn",
                    op: SqlOperation.EQUAL
                }]
            }
        },
    ]
}
